import { crud, update } from "./crud";
import { httpPost } from "../services/http";


const us = document.querySelector('#user') ? JSON.parse(document.querySelector('#user').value) : {};

const defaultState = {
	_id: us._id ? us._id : 0,
	logged: us.logged,
	Name: us.name,
	name: us.name,
	phone: us.phone,
	Role: us.Role ? us.Role : false
};


export const user = (state = defaultState, action) => crud('user', state, action, () => state, 'object');

export const login = (data) => update('user', 'users/login', data);
export const register = (data) => {
	return (dispatch) => {
		httpPost('users/register', data)
			.then(data => {})
	}
};